import LocomotiveScroll from 'locomotive-scroll';
import { prefersReducedMotion } from '../motion';
export { initFooterLinkFocus } from './focus'

let activeScroll: LocomotiveScroll | null = null;

export const initSmoothScroll = (): LocomotiveScroll | null => {
    if (activeScroll) {
        activeScroll.destroy();
        activeScroll = null;
    }

    if (prefersReducedMotion()) {
        return null;
    }

    activeScroll = new LocomotiveScroll({
        lenisOptions: {
            wrapper: window,
            content: document.documentElement,
            lerp: 0.1,
            duration: 1.2,
            orientation: 'vertical',
            gestureOrientation: 'vertical',
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
        },
    });

    return activeScroll;
}
